import { cfg } from "../../configuracion";

export const putCorreoConfirmacion = async (idioma, json, token) => {
    let respuesta = {
        datos: null,
        error: null
    };

    try {
        const url = `${cfg.apiUrl}/residente/${json.nif}/${json.tipo}/reenvioregistro`;

        console.log("URL:", url);
        console.log("Datos antes de enviar:", {
            idioma,
            nif: json.nif,
            tipo: json.tipo,
            token
        });

        const resp = await fetch(url, {
            method: 'PUT',
            headers: {
                'Accept-Language': idioma,
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',

                // Deshabilitar provisionalmente la caché
                "Cache-Control": "no-cache, no-store, must-revalidate",
                Pragma: "no-cache",
                Expires: "0"
            }
        });

        const respj = await resp.json();
      
        if (resp.status === 200 && respj.ok) {
            respuesta = { ...respuesta, datos: {} };
        } else {
            respuesta = { ...respuesta, error: respj.mensaje ? respj.mensaje : "Error: " + resp.status };
        }
    } catch (error) {
        console.error("Error en el envío de datos:", error);
        respuesta.error = `Error en el envío de datos: ${error.message}`;
    }
    
    return respuesta;
};
